import { ArrowForward } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router-dom';

import CButton from '../CButton';
import CLocalizedText from '../CLocalizedText';
import CLocalizedTextString from '../CLocalizedTextString';
import CPageModule from '../CPageModule';
import Page from '../layout/Page';

interface NotFoundModuleProps {
  title?: string;
  loginButtonVisible?: boolean;
  onLoginClick?: () => void | Promise<void>;
}

export default function NotFoundModule(props: NotFoundModuleProps) {
  return (
    <Page title={props.title ?? CLocalizedTextString('globalTitleNotFound')}>
      <div className={'flex flex-col items-center gap-4 justify-center h-[80vh]'}>
        <CPageModule>
          <h2 className={'text-center'}>
            <CLocalizedText dictKey={'globalErrorNotFound'} />
          </h2>
          <p className={'text-center'}>
            <CLocalizedText dictKey={'globalErrorContactAdmin'} />
          </p>
        </CPageModule>
        <CPageModule style={{ paddingTop: 0 }}>
          <div className={'flex items-center gap-3'}>
            <Link to={'/'} replace>
              <CButton
                icons={{ end: !props.loginButtonVisible ? <ArrowForward /> : <></> }}
                style={{ borderWidth: '1px', justifyContent: 'center' }}
              >
                <CLocalizedText dictKey={'globalErrorReturnToHomepage'} />
              </CButton>
            </Link>
            {props.loginButtonVisible ? (
              <CButton
                icons={{ end: <ArrowForward /> }}
                onClick={props.onLoginClick}
                style={{ borderWidth: '1px', justifyContent: 'center' }}
              >
                <CLocalizedText dictKey={'globalLogIn'} />
              </CButton>
            ) : null}
          </div>
        </CPageModule>
      </div>
    </Page>
  );
}
